<div>
    <h1>{{ title }}</h1>
    
    <div *ngIf="isLoadingTrades || isLoadingCounterpartyTrades || isLoadingFreightChat || isLoadingOriginationChat || isLoadingFreightFixtures" 
         class="loading-message">
        <mat-icon class="loading-icon" [class.rotating]="isRetrying">sync</mat-icon>
        <span>
            {{ getLoadingMessage() }}
            <span *ngIf="searchError" class="error-message">{{ searchError }}</span>
        </span>
    </div>

    <div class="search-form">
        <div class="search-row">
            <div class="search-inputs">
                <mat-form-field appearance="fill" class="period-field">
                    <mat-label>Period</mat-label>
                    <input type="text" matInput [(ngModel)]="selectedPeriod" name="period" [matAutocomplete]="autoPeriod">
                    <mat-autocomplete #autoPeriod="matAutocomplete" (optionSelected)="onPeriodSelection($event.option.value)">
                        <mat-option *ngFor="let period of periods" [value]="period">{{ period }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="fill" class="year-field">
                    <mat-label>Year</mat-label>
                    <input type="text" matInput [(ngModel)]="selectedYear" name="year" [matAutocomplete]="autoYear">
                    <mat-autocomplete #autoYear="matAutocomplete" (optionSelected)="onYearSelection($event.option.value)">
                        <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="fill" class="search-field">
                    <mat-label>Search Terms</mat-label>
                    <input matInput [(ngModel)]="searchTerm" name="searchTerm" 
                           (keyup.enter)="onSearch()" />
                </mat-form-field>

                <button mat-raised-button color="primary" 
                        (click)="onSearch()"
                        [disabled]="isLoadingTrades || isLoadingCounterpartyTrades">
                    {{ (isLoadingTrades || isLoadingCounterpartyTrades) ? 'Loading...' : 'Search' }}
                </button>
            </div>
        </div>
    </div>

    <div class="controls-row">
        <div class="filter-buttons">
            <mat-button-toggle-group multiple>
                <mat-button-toggle 
                    [checked]="messageFilters.showMessages"
                    [disabled]="messageFilters.showMessages && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showMessages', $event.source.checked)">
                    <mat-icon>chat</mat-icon>
                    Trader Messages
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showFreightChat"
                    [disabled]="messageFilters.showFreightChat && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showFreightChat', $event.source.checked)">
                    <mat-icon>chat_bubble</mat-icon>
                    Freight Market
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showOriginationChat"
                    [disabled]="messageFilters.showOriginationChat && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showOriginationChat', $event.source.checked)">
                    <mat-icon>forum</mat-icon>
                    Origination Market
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showMarketNews"
                    [disabled]="messageFilters.showMarketNews && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showMarketNews', $event.source.checked)">
                    <mat-icon>feed</mat-icon>
                    Market News
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showTenders"
                    [disabled]="messageFilters.showTenders && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showTenders', $event.source.checked)">
                    <mat-icon>list_alt</mat-icon>
                    Tenders
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showFreightFixtures"
                    [disabled]="messageFilters.showFreightFixtures && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showFreightFixtures', $event.source.checked)">
                    <mat-icon>anchor</mat-icon>
                    Freight Fixtures
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showTrades"
                    [disabled]="messageFilters.showTrades && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showTrades', $event.source.checked)">
                    <mat-icon>receipt_long</mat-icon>
                    JeraGM Trades
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showPlattsFinancial"
                    [disabled]="messageFilters.showPlattsFinancial && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showPlattsFinancial', $event.source.checked)">
                    <mat-icon>trending_up</mat-icon>
                    Platts Financial
                </mat-button-toggle>
                <mat-button-toggle 
                    [checked]="messageFilters.showPlattsPhysical"
                    [disabled]="messageFilters.showPlattsPhysical && getActiveFilterCount() === 1"
                    (change)="onFilterChange('showPlattsPhysical', $event.source.checked)">
                    <mat-icon>directions_boat</mat-icon>
                    Platts Physical
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <div class="view-controls">
            <mat-button-toggle-group [(ngModel)]="viewMode" aria-label="View Mode" class="responsive-toggle-group">
                <mat-button-toggle value="table">
                    <mat-icon>table_chart</mat-icon>
                    <span class="button-text">Table</span>
                </mat-button-toggle>
                <mat-button-toggle value="timeline">
                    <mat-icon>view_timeline</mat-icon>
                    <span class="button-text">Timeline</span>
                </mat-button-toggle>
            </mat-button-toggle-group>

            <!-- <button mat-raised-button color="primary" 
                    [disabled]="!filteredMessages.length"
                    (click)="openGraphicalView(filteredMessages)"
                    class="graphical-view-button">
                <mat-icon>timeline</mat-icon>
                <span class="button-text">Open Graphical View</span>
            </button> -->
        </div>
    </div>

    <div *ngIf="filteredMessages.length > 0" style="margin-top: 20px;">
        <div *ngFor="let month of filteredMessages" class="month-container">
            <div class="month-header-container">
                <h2 class="month-header">
                    {{ searchOnlyMode ? 'Search Results' : 
                       (activeSearchYear ? 
                           (!selectedPeriod ? activeSearchYear : month.name + ' ' + month.year) : 
                           (!selectedPeriod && !selectedYear && !searchTerm.trim() ? 'Search Results for Last 12 Months' : 'Search Results')) }}
                </h2>
                <button mat-raised-button 
                        color="primary" 
                        (click)="exportToExcel(month)"
                        class="export-button">
                    <mat-icon>download</mat-icon>
                    Export to Excel
                </button>
            </div>
            
            <!-- Timeline View with Pagination -->
            <div *ngIf="viewMode === 'timeline'" class="timeline-container">
                <div *ngFor="let message of getPaginatedMessages(month.messages)" 
                     class="timeline-entry"
                     [ngClass]="{
                         'message-entry': !message.text?.startsWith('Trade:') && 
                                         !message.text?.startsWith('Platts Financial Trade') && 
                                         !message.text?.startsWith('Platts Physical Trade') &&
                                         !message.text?.startsWith('Freight') &&
                                         !message.text?.startsWith('Origination') &&
                                         !message.text?.startsWith('Market News'),
                         'trade-entry': message.text?.startsWith('Trade:'),
                         'platts-financial-entry': message.text?.startsWith('Platts Financial Trade'),
                         'platts-physical-entry': message.text?.startsWith('Platts Physical Trade'),
                         'freight-chat-entry': message.text?.startsWith('Freight'),
                         'origination-chat-entry': message.text?.startsWith('Origination'),
                         'market-news-entry': message.text?.startsWith('Market News')
                     }">
                    <div class="entry-timestamp">{{ message.timestamp }}</div>
                    <div class="entry-content">
                        <mat-icon class="entry-icon" [ngStyle]="{'color': getMessageIconColor(message.text)}">
                            {{ getMessageIcon(message.text) }}
                        </mat-icon>
                        <div>
                            <div [innerHTML]="boldHeader(message.header)" 
                                 [ngClass]="{
                                   'asia-lng-derivative': message.text?.includes('Asia LNG Derivative'),
                                   'asia-lng-physical': message.text?.includes('Asia LNG Physical')
                                 }"></div>
                            <div class="message-container">
                                <div class="message-text" 
                                     [ngClass]="{
                                       'long-message': isLongMessage(message.text),
                                       'truncated-message': isLongMessage(message.text) && !isMessageExpanded(message.timestamp + message.text.substring(0, 20)),
                                       'expanded-message': isLongMessage(message.text) && isMessageExpanded(message.timestamp + message.text.substring(0, 20))
                                     }"
                                     [innerHTML]="message.text"></div>
                                
                                <div *ngIf="isLongMessage(message.text)" 
                                     class="message-expand-indicator"
                                     (click)="toggleMessageExpansion(message.timestamp + message.text.substring(0, 20))">
                                    <span>{{ isMessageExpanded(message.timestamp + message.text.substring(0, 20)) ? 'Show Less' : 'Show More' }}</span>
                                    <mat-icon>{{ isMessageExpanded(message.timestamp + message.text.substring(0, 20)) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <mat-paginator
                    [length]="month.messages.length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    [pageIndex]="currentPage"
                    (page)="onPageChange($event, month)"
                    aria-label="Select page">
                </mat-paginator>
            </div>

            <!-- Table View with Pagination -->
            <div *ngIf="viewMode === 'table'">
                <table mat-table [dataSource]="getPaginatedMessages(month.messages)" class="message-table">
                    <ng-container matColumnDef="header">
                        <th mat-header-cell *matHeaderCellDef class="header-column"> Entry </th>
                        <td mat-cell *matCellDef="let message">
                            <mat-icon class="entry-icon" [ngStyle]="{'color': getMessageIconColor(message.text)}">
                                {{ getMessageIcon(message.text) }}
                            </mat-icon>
                            <span [innerHTML]="boldHeader(message.header)" style="margin-left: 8px;"></span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="text">
                        <th mat-header-cell *matHeaderCellDef class="text-column"> Details </th>
                        <td mat-cell *matCellDef="let message" class="message-cell" 
                            [ngStyle]="{
                                'color': message.text.startsWith('Asia LNG Derivative') ? '#fbc02d' : 
                                         message.text.startsWith('Asia LNG Physical') ? '#2e7d32' : 
                                         message.text.startsWith('Market News') ? '#673ab7' : 'inherit'
                            }"> 
                            <div class="message-container">
                                <div class="message-text" 
                                     [ngClass]="{
                                       'long-message': isLongMessage(message.text),
                                       'truncated-message': isLongMessage(message.text) && !isMessageExpanded(message.timestamp + message.text.substring(0, 20)),
                                       'expanded-message': isLongMessage(message.text) && isMessageExpanded(message.timestamp + message.text.substring(0, 20))
                                     }"
                                     [innerHTML]="message.text"></div>
                                
                                <div *ngIf="isLongMessage(message.text)" 
                                     class="message-expand-indicator"
                                     (click)="toggleMessageExpansion(message.timestamp + message.text.substring(0, 20))">
                                    <span>{{ isMessageExpanded(message.timestamp + message.text.substring(0, 20)) ? 'Show Less' : 'Show More' }}</span>
                                    <mat-icon>{{ isMessageExpanded(message.timestamp + message.text.substring(0, 20)) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="timestamp">
                        <th mat-header-cell *matHeaderCellDef class="timestamp-column"> Time of Entry </th>
                        <td mat-cell *matCellDef="let message"> {{ message.timestamp }} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="['header', 'text', 'timestamp']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['header', 'text', 'timestamp'];"
                        [ngClass]="{
                            'message-row': !row.text.startsWith('Trade:') && 
                                          !row.text.startsWith('Platts Financial Trade') && 
                                          !row.text.startsWith('Platts Physical Trade') &&
                                          !row.text.startsWith('Freight') &&
                                          !row.text.startsWith('Origination') &&
                                          !row.text.startsWith('Market News'),
                            'trade-row': row.text.startsWith('Trade:'),
                            'platts-financial-row': row.text.startsWith('Platts Financial Trade'),
                            'platts-physical-row': row.text.startsWith('Platts Physical Trade'),
                            'freight-chat-row': row.text.startsWith('Freight'),
                            'origination-chat-row': row.text.startsWith('Origination'),
                            'market-news-row': row.text.startsWith('Market News')
                        }">
                    </tr>
                </table>
                
                <mat-paginator
                    [length]="month.messages.length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    [pageIndex]="currentPage"
                    (page)="onPageChange($event, month)"
                    aria-label="Select page">
                </mat-paginator>
            </div>
        </div>
    </div>

    <div *ngIf="filteredMessages.length === 0" class="no-results-message" style="margin-top: 20px; text-align: center;">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">info</mat-icon>
        No results found. Try adjusting your search criteria or filters.
    </div>
</div>